import React, { useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useController } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../ForceAccountsBlock/styles';
import CloseIcon from 'assets/images/close-icon.svg';
import cn from 'classnames';

const PayrollBlock = ({ classes, pageType, control, errors }) => {

  const {
    field: { onChange, value: payrollValues },
  } = useController({
    name: 'payrollAdminEmail',
    control,
  });

  const [isShowEmailsPayroll, setShowEmailsPayroll] = useState(false);


  const handleEmailChange = (i) => (e) => {
    const { value } = e.target;
    const nextValue = payrollValues.map((t, index) => (index === i ? value : t));
    onChange(nextValue);
  };
  const handleEmailRemoving = (i) => () => {
    const nextValue = payrollValues.filter((_, index) => index !== i);
    onChange(nextValue);
  };

  const handleAddEmail = () => {
    setShowEmailsPayroll(true);
    onChange([...payrollValues.filter((v) => v.length), '']);
  };

  return (
    <div>
      <div className={classes.actionsWrapper}>
        {!!payrollValues?.length &&
          payrollValues
            .slice(0, isShowEmailsPayroll ? payrollValues.length : 3)
            .map((email, index) => (
              <Grid container spacing={2} key={`payrollAdminEmail-${index}`} alignItems="center">
                <Grid item xs={10} sm={6} md={4} className={classes.zeroPaddingTop}>
                  {index === 0 && (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      className={classes.regularFontWeight}
                    >
                      Email:
                    </Typography>
                  )}
                  <TextField
                    id={`payrollAdminEmail[${index}]`}
                    name={`payrollAdminEmail[${index}]`}
                    type="email"
                    value={email}
                    className={classes.textField}
                    onChange={handleEmailChange(index)}
                    variant="outlined"
                    inputProps={{ 'aria-label': 'Payroll Admin Email' }}
                    fullWidth
                    disabled={pageType === 'read'}
                  />
                </Grid>
                {pageType === 'edit' && (
                  <span
                    className={classes.removeEmail}
                    onClick={handleEmailRemoving(index)}
                    style={index === 0 ? { marginTop: 15 } : {}}
                  >
                    <img src={CloseIcon} alt="delete" />
                  </span>
                )}
              </Grid>
            ))}
        {payrollValues?.length > 3 && (
          <div
            className={classes.buttonWrapper}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowEmailsPayroll((prev) => !prev);
            }}
          >
            <div className={classes.nonActionsIcon}>
              <ExpandMoreIcon className={cn(isShowEmailsPayroll ? '' : classes.reversIcon)} />
            </div>
            <p className={classes.textIconMore}>{`${
              isShowEmailsPayroll ? 'Hide' : 'Show'
            } additional email addresses`}</p>
          </div>
        )}
        {pageType === 'edit' && (
          <Button
            variant="text"
            className={classes.primaryTextButton}
            onClick={handleAddEmail}
            disableRipple
          >
            + Add Email
          </Button>
        )}
      </div>
    </div>
  );
};

PayrollBlock.propTypes = {
  classes: propTypes.object.isRequired,
  pageType: propTypes.string.isRequired,
  errors: propTypes.object.isRequired,
};

export default withStyles(styles)(PayrollBlock);
